import {
  createContext,
  FC,
  PropsWithChildren,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import { Trigger } from 'client/voladeum/triggers/types';

import { trigger_context_initial_state } from './defaults';
import { TriggerContextProps } from './types';

const Context = createContext<TriggerContextProps>({ ...trigger_context_initial_state });

export const TriggerContext: FC<PropsWithChildren> = ({ children }) => {
  const [context, setContext] = useState<TriggerContextProps>({ ...trigger_context_initial_state });

  const setTrigger = useCallback((trigger: Trigger) => {
    setContext((prev) => ({ ...prev, trigger }));
  }, []);

  const updateTrigger = useCallback((trigger: Partial<Trigger>) => {
    setContext((prev) => {
      return { ...prev, trigger: { ...prev.trigger, ...trigger } };
    });
  }, []);

  const value = useMemo(
    () => ({ ...context, setTrigger, updateTrigger }),
    [context, setTrigger, updateTrigger]
  );

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useTriggerContext = () => useContext(Context);
